import React from 'react';
import ContentLoader from 'react-content-loader';
import { Box } from '@mafc/trolly';

import OrderSummaryLayout from './OrderSummaryLayout';

const displayPropXS = ['block', '', 'none'];
const displayPropMD = ['none', '', 'block', 'none'];
const displayPropLG = ['none', '', '', 'block'];

const OrderSummaryTitleLoader: React.FC<{ width: number }> = props => (
  <ContentLoader
    className="skeleton-loader"
    height={20}
    width={450}
    speed={2}
    primaryColor="#f3f3f3"
    secondaryColor="#ecebeb"
    {...props}
  >
    <rect x="0" y="4" rx="5" ry="5" width="160" height="12" />
  </ContentLoader>
);
const OrderSummaryTitleLoaders: React.FC = () => (
  <>
    <Box display={displayPropXS}>
      <OrderSummaryTitleLoader width={450} />
    </Box>
    <Box display={displayPropMD}>
      <OrderSummaryTitleLoader width={800} />
    </Box>
    <Box display={displayPropLG}>
      <OrderSummaryTitleLoader width={400} />
    </Box>
  </>
);

const OrderSummaryContentLoader: React.FC = () => (
  <>
    <Box display={displayPropXS}>
      <ContentLoader
        className="skeleton-loader"
        height={122}
        width={450}
        speed={2}
        primaryColor="#f3f3f3"
        secondaryColor="#ecebeb"
      >
        <rect x="0" y="10" rx="5" ry="5" width="120" height="10" />
        <rect x="330" y="10" rx="5" ry="5" width="120" height="10" />

        <rect x="0" y="48" rx="5" ry="5" width="120" height="10" />
        <rect x="330" y="48" rx="5" ry="5" width="120" height="10" />

        <rect x="0" y="86" rx="5" ry="5" width="120" height="10" />
        <rect x="330" y="86" rx="5" ry="5" width="120" height="10" />
      </ContentLoader>
    </Box>
    <Box display={displayPropMD}>
      <ContentLoader
        className="skeleton-loader"
        height={122}
        width={800}
        speed={2}
        primaryColor="#f3f3f3"
        secondaryColor="#ecebeb"
      >
        <rect x="0" y="10" rx="5" ry="5" width="120" height="10" />
        <rect x="680" y="10" rx="5" ry="5" width="120" height="10" />

        <rect x="0" y="48" rx="5" ry="5" width="120" height="10" />
        <rect x="680" y="48" rx="5" ry="5" width="120" height="10" />

        <rect x="0" y="86" rx="5" ry="5" width="120" height="10" />
        <rect x="680" y="86" rx="5" ry="5" width="120" height="10" />
      </ContentLoader>
    </Box>
    <Box display={displayPropLG}>
      <ContentLoader
        className="skeleton-loader"
        height={244}
        width={400}
        speed={2}
        primaryColor="#f3f3f3"
        secondaryColor="#ecebeb"
      >
        <rect x="0" y="10" rx="5" ry="5" width="120" height="10" />
        <rect x="280" y="10" rx="5" ry="5" width="120" height="10" />

        <rect x="0" y="48" rx="5" ry="5" width="120" height="10" />
        <rect x="280" y="48" rx="5" ry="5" width="120" height="10" />

        <rect x="0" y="86" rx="5" ry="5" width="120" height="10" />
        <rect x="280" y="86" rx="5" ry="5" width="120" height="10" />

        <rect x="0" y="130" rx="1" ry="1" width="400" height="50" />
        <rect x="0" y="196" rx="1" ry="1" width="400" height="50" />
      </ContentLoader>
    </Box>
  </>
);

const OrderSummaryLoader: React.FC<{ hideBinLoading?: boolean }> = ({ hideBinLoading = true }) => (
  <OrderSummaryLayout title={<OrderSummaryTitleLoaders />} hideBinLoading={hideBinLoading}>
    <OrderSummaryContentLoader />
  </OrderSummaryLayout>
);

export default OrderSummaryLoader;
